<script setup>
import { Download } from 'lucide-vue-next'

// Botão de download das três listas de documentos (Documentos, card da Visão
// Geral e comprovantes em Pagamentos). Sem arquivo anexado ele não vira link:
// a linha continua visível, mas não promete um download que não existe.
defineProps({
  id: { type: Number, required: true },
  name: { type: String, required: true },
  available: { type: Boolean, default: false },
  // O fundo do hover muda conforme o cartão em que a lista está.
  hoverClass: { type: String, default: 'hover:bg-up-bg' },
})
</script>

<template>
  <!-- <a> e não <Link>: download é navegação do navegador, não visita da SPA. -->
  <a
    v-if="available"
    :href="`/documentos/${id}/arquivo`"
    download
    class="ml-auto shrink-0 rounded-md p-2 text-up-navy transition-colors"
    :class="hoverClass"
    :aria-label="`Baixar ${name}`"
  >
    <Download class="h-5 w-5" aria-hidden="true" />
  </a>
  <span v-else class="ml-auto shrink-0 p-2 text-slate-300" :title="`${name}: arquivo ainda não disponível`">
    <Download class="h-5 w-5" aria-hidden="true" />
    <span class="sr-only">{{ name }}: arquivo ainda não disponível</span>
  </span>
</template>
